import { render } from "./MapboxAttribution.vue?vue&type=template&id=78c1bca2&scoped=true"
const script = {}

import "./MapboxAttribution.vue?vue&type=style&index=0&id=78c1bca2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c1bca2"]])

export default __exports__